<script>
// Custom Components
import PageHeader from "@/components/page-header";
import TicketService from "@/helpers/APIService/ticket.service";
import middlewares from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import appConfig from "@/app.config";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "Tracking Reports",
      table: {
        tableData: [],
        totalPages: 1,
        pageNumber: 1,
        size: 50,
      },
      isLoading: false,
    };
  },
  mounted() {
    this.getTrackReportList();
  },
  methods: {
    // Method is used to get my ticket list
    async getTrackReportList() {
      try {
        this.isLoading = true;
        const response = await TicketService.getTicketByAgent();
        if (response.status == false) {
          this.isLoading = false;
          return middlewares.notification(response.message, "warning");
        }
        this.table.tableData = response.result.map((item) => {
          item = {
            ...item,
            total_ticket: item.closed + item.in_progress,
          };
          return item;
        });
        this.table.pageNumber = response.page_number;
        this.table.totalPages = response.count;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="goBack"
      text="Go Back"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light" slot="head">
            <tr>
              <th>Employee</th>
              <th>Total Tickets</th>
              <th>In Progress Tickets</th>
              <th>Closed Tickets</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 4" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(track, index) in table.tableData" :key="index">
              <td>{{ track.assign_to_user_name }}</td>
              <td>{{ track.total_ticket }}</td>
              <td>{{ track.in_progress }}</td>
              <td>{{ track.closed }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>
